import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    IconButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    TableCell,
    Typography,
    Tooltip
} from "@mui/material";
import {Close, Delete, Edit, MoreVert, History, ContentCopy, Description, Download, Add} from "@mui/icons-material";
import {NavLink, useNavigate} from "react-router-dom";
import {translate} from "../../translate/translate";
import * as React from "react";
import {useEffect, useState} from "react";
import {useAuth} from "../../contexts/auth-context";

const TableMenuComponent = (props: any) => {
    const {
        row,
        handleOpenDialogHistory,
        editWithDialog,
        handleDelete,
        showActions,
        actionsHints,
        handleDuplicate,
        menuLayout = false,
        goToDetail,
        downloadFn,
        handleAddChild,
        customMenuItems,
        backgroundColor,
        isNpiTemplate = false,
    } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const openUserPanel = Boolean(anchorEl);
    const [open, setOpen] = React.useState(false);
    const {user} = useAuth();
    const isCurrentUser = row.id === user?.id && row.username === user?.username;
    const isNpiDeleteBlocked = isNpiTemplate && !!row.in_use;

    useEffect(() => {
        console.log(menuLayout)
    }, []);

    const handleOpenDialog = () => {
        setOpen(true);
    };

    const handleCloseDialog = () => {
        setOpen(false);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    return (
        <>
        {!!menuLayout ? (
            <TableCell align="center"
                       sx={{
                           backgroundColor: backgroundColor
                       }}>
                <IconButton color="secondary" size="small" onClick={handleClick}>
                    <MoreVert sx={{ fontSize: "28px" }} />
                </IconButton>
                <Menu
                    id="demo-positioned-menu"
                    aria-labelledby="demo-positioned-button"
                    anchorEl={anchorEl}
                    open={openUserPanel}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                >
                    {showActions?.includes("add_child") && (
                        <MenuItem
                            onClick={() => {
                                handleAddChild(row);
                            }}
                        >
                            <ListItemIcon>
                                <Add />
                            </ListItemIcon>
                            <ListItemText>{translate.t("add")}</ListItemText>
                        </MenuItem>
                    )}
                    {(!showActions || showActions.includes("history")) && (
                        <MenuItem
                            onClick={() => {
                                handleOpenDialogHistory(row.id);
                            }}
                        >
                            <ListItemIcon>
                                <History />
                            </ListItemIcon>
                            <ListItemText>{translate.t("history")}</ListItemText>
                        </MenuItem>
                    )}
                    {(!showActions || showActions.includes("edit")) && (
                        editWithDialog ? (
                            <MenuItem
                                onClick={() => {
                                    if (editWithDialog) editWithDialog(row);
                                }}
                            >
                                <ListItemIcon>
                                    <Edit />
                                </ListItemIcon>
                                <ListItemText>{translate.t("edit")}</ListItemText>
                            </MenuItem>
                        ) : (
                            <MenuItem
                                component={NavLink}
                                to={`${props.url}${row.id}`}
                                onClick={() => {
                                    if (editWithDialog) editWithDialog(row);
                                }}
                            >
                                <ListItemIcon>
                                    <Edit />
                                </ListItemIcon>
                                <ListItemText>{translate.t("edit")}</ListItemText>
                            </MenuItem>
                        )
                    )}
                    {(!showActions || showActions.includes("delete")) && (
                        <MenuItem
                            onClick={() => {
                                if (!isCurrentUser) {
                                    handleOpenDialog();
                                }
                            }}
                            disabled={isCurrentUser}
                        >
                            <ListItemIcon>
                                <Delete />
                            </ListItemIcon>
                            <ListItemText>{translate.t("delete")}</ListItemText>
                        </MenuItem>
                    )}
                    {showActions?.includes("duplicate") && (
                        <MenuItem
                            onClick={() => {
                                handleDuplicate(row);
                            }}
                        >
                            <ListItemIcon>
                                <ContentCopy />
                            </ListItemIcon>
                            <ListItemText>{translate.t("duplicate")}</ListItemText>
                        </MenuItem>
                    )}
                    {showActions?.includes("download") && (
                        <MenuItem
                            onClick={() => {
                                downloadFn(row);
                            }}
                        >
                            <ListItemIcon>
                                <Download />
                            </ListItemIcon>
                            <ListItemText>{translate.t("download")}</ListItemText>
                        </MenuItem>
                    )}
                    {showActions?.includes("custom") && (
                        customMenuItems(row)
                    )}
                </Menu>
            </TableCell>
        ) : (
            <TableCell align="center" style={{ whiteSpace: 'nowrap' }}>
                {showActions?.includes("add_child") && (
                    <Tooltip title={actionsHints && actionsHints[showActions?.indexOf("add_child")]
                      ? translate.t(actionsHints[showActions?.indexOf("add_child")])
                      : translate.t("add")} placement="top"
                    >
                        <IconButton
                            onClick={() => {
                                handleAddChild(row);
                            }}
                        >
                            <Add />
                        </IconButton>
                    </Tooltip>
                )}
                {(!showActions || showActions.includes("history")) && (
                    <IconButton
                        onClick={() => {
                            handleOpenDialogHistory(row.id);
                        }}
                    >
                        <History />
                    </IconButton>
                )}
                {(!showActions || showActions.includes("edit")) && (
                    editWithDialog ? (
                            <Tooltip title={actionsHints && actionsHints[showActions?.indexOf("edit")]
                              ? translate.t(actionsHints[showActions?.indexOf("edit")])
                              : translate.t("edit")} placement="top">
                                <IconButton
                                    onClick={() => {
                                        if (editWithDialog) editWithDialog(row);
                                    }}
                                >
                                    <Edit />
                                </IconButton>
                            </Tooltip>
                    ) : (
                        <Tooltip title={actionsHints && actionsHints[showActions?.indexOf("edit")]
                          ? translate.t(actionsHints[showActions?.indexOf("edit")])
                          : translate.t("edit")} placement="top">
                            <IconButton
                                component={NavLink}
                                to={`${props.url ?? ''}${row.id}`}
                            >
                                <Edit />
                            </IconButton>
                        </Tooltip>
                    )
                )}
                {(!showActions || showActions.includes("delete")) && !isNpiDeleteBlocked && (
                    <Tooltip title={actionsHints && actionsHints[showActions?.indexOf("delete")]
                      ? translate.t(actionsHints[showActions?.indexOf("delete")])
                      : translate.t("delete")} placement="top">
                        <IconButton
                            onClick={() => {
                                if (!isCurrentUser) {
                                    handleOpenDialog();
                                }
                            }}
                            disabled={isCurrentUser}
                        >
                            <Delete />
                        </IconButton>
                    </Tooltip>
                )}
                {isNpiDeleteBlocked && (
                    <Tooltip title={translate.t("template_linked_to_npi")} placement="top">
                        <span>
                            <IconButton disabled>
                                <Delete />
                            </IconButton>
                        </span>
                    </Tooltip>
                )}
                {(!showActions || showActions.includes("detail")) && (
                    <Tooltip title={actionsHints && actionsHints[showActions?.indexOf("detail")]
                      ? translate.t(actionsHints[showActions?.indexOf("detail")])
                      : translate.t("detail")} placement="top">
                        <IconButton
                            onClick={() => {
                                goToDetail();
                            }}
                            disabled={isCurrentUser}
                        >
                            <Description />
                        </IconButton>
                    </Tooltip>
                )}
                {showActions?.includes("download") && (
                    <Tooltip title={actionsHints && actionsHints[showActions?.indexOf("download")]
                      ? translate.t(actionsHints[showActions?.indexOf("download")])
                      : translate.t("download")} placement="top">
                        <IconButton
                            onClick={() => {
                                downloadFn(row);
                            }}
                        >
                            <Download />
                        </IconButton>
                    </Tooltip>
                )}
            </TableCell>
        )}
            <Dialog open={open} onClose={handleCloseDialog}>
                <Grid padding={2} container justifyContent="space-between" sx={{backgroundColor: "primary.main"}}>
                    <Grid >
                        <Typography sx={{color: "#ffffff", fontWeight: "bold", fontSize: "16px"}}>
                            {translate.t("delete")}
                        </Typography>
                    </Grid>
                    <Grid sx={{cursor: "pointer", color: "#ffffff"}}>
                        <Close onClick={() => {
                            handleCloseDialog();
                        }}/>
                    </Grid>
                </Grid>
                <DialogContent>
                    <Grid container flexDirection="column" gap={1}>
                        <Grid >
                            <Typography>
                                {translate.t("confirm_delete")}
                            </Typography>
                        </Grid>
                        {
                            row.name !== undefined && (
                                <Grid >
                                    <Typography sx={{fontWeight: "bold"}}>
                                        {row.name}
                                    </Typography>
                                </Grid>
                            )
                        }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="flex-end" gap={1} padding={2}>
                        <Grid >
                            <Button
                                color="secondary"
                                variant="outlined"
                                onClick={() => {
                                    handleCloseDialog();
                                }}>{translate.t("cancel")}</Button>
                        </Grid>
                        <Grid >
                            <Button
                                variant="contained"
                                color="error"

                                onClick={() => {
                                    handleDelete(row);
                                    setAnchorEl(null);
                                    handleCloseDialog();
                                }}>{translate.t("delete")}</Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default TableMenuComponent;
